import { useIsMobile } from "@src/appV2/redesign/AppLayout/useResponsive";
import { Platform } from "@src/mobile/utils/platform";

import { useIsDailyViewEnabled } from "./useIsDailyViewEnabled";

/**
 * Returns true when the user should be redirected to /schedule on login.
 *
 * Both conditions must be met:
 * 1. The viewport is mobile-sized or running in a native mobile app
 * 2. The Daily View feature itself is enabled (DAILY_VIEW_ENABLED)
 *
 * Checking DAILY_VIEW_ENABLED prevents a redirect loop: without it the user
 * would land on /schedule, DailyView.tsx would redirect to /calendar, and
 * the catch-all would send them back to /schedule.
 */
export function useShouldRedirectToDailyView(): boolean {
  const isMobileViewport = useIsMobile();
  const isDailyViewEnabled = useIsDailyViewEnabled();

  return (isMobileViewport || Platform.isMobile) && isDailyViewEnabled;
}
